import React from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import { useAuthenticate } from './../../hooks/useAuthenticate';
import { getSessionInfo } from '../../utils/getSessionInfo';
import { hasAssignedLocations } from '../../utils/funcs';
import { getUserRoles } from '../../utils/getUserRole';

const Private = ({ children }: { children: React.ReactNode }) => {
	const isAuthenticated = useAuthenticate();
	const location = useLocation();

	if (!isAuthenticated) {
		return <Navigate to="/login" />;
	}

	const { userInfo } = getSessionInfo();

	if (
		!userInfo?.flags?.passcodeEnabled &&
		location.pathname !== '/passcode' &&
		location.pathname !== '/select-location' &&
		!!userInfo
	) {
		return <Navigate to="/passcode" />;
	}

	const { isOwner } = getUserRoles();
	const hasNoLocation = !hasAssignedLocations(userInfo);
	if (isOwner && hasNoLocation && location.pathname !== '/select-location' && location.pathname !== '/passcode') {
		return <Navigate to="/select-location" />;
	}

	return <>{children}</>;
};

export default Private;
